import { Outlet, RouteObject, useRoutes } from "react-router-dom";
import Layout from "../layout/Layout";
import { routesConstants } from "../utils/constants";
import { LoginScreen, RegisterScreen } from "../screen/auth";
import { DashboardScreen } from "../screen/dashboard";
import { ProjectsScreen } from "../screen/projects";
import { LiveChatScreen } from "../screen/live-chat";
import { HistoryScreen } from "../screen/history";
import { ContactsScreen } from "../screen/contacts";
import { CampaignsDetailScreen, CampaignsScreen } from "../screen/campaigns";
import { AdsManagerScreen } from "../screen/ads-manager";
import { FlowScreen } from "../screen/flow";
import {
  AgentsScreen,
  AnalyticsScreen,
  ApiKeyScreen,
  BillingUsagesScreen,
  CannedMessageScreen,
  LiveChatSettingScreen,
  ManageLayoutScreen,
  NotificationPreferencesScreen,
  OptinManagementScreen,
  TagsScreen,
  UserAttributesScreen,
} from "../screen/manage";
import { SocketProvider } from "../context/SocketContext";
import { ProfileLayoutScreen, YourProfileScreen } from "../screen/profile";
import { UserUpdateSelfProfileScreen } from "../screen/user";
import ProjectAuthProtectedRoute from "./ProjectAuthProtectedRoute";
import AuthProtectedRoute from "./AuthProtectedRoute";
import {
  CreateTemplateMessageScreen,
  TemplateMessageScreen,
} from "../screen/template";
import TemplateLayout from "../screen/template/TemplateLayout";

const configRoutes: RouteObject[] = [
  {
    path: routesConstants.projects,
    element: (
      <AuthProtectedRoute>
        <ProjectsScreen />
      </AuthProtectedRoute>
    ),
  },
  {
    path: routesConstants.updateProfile,
    element: <UserUpdateSelfProfileScreen />,
  },
  {
    path: routesConstants.home,
    element: (
      <ProjectAuthProtectedRoute>
        <Layout>
          <Outlet />
        </Layout>
      </ProjectAuthProtectedRoute>
    ),

    children: [
      {
        path: routesConstants.home,
        element: <DashboardScreen />,
        // errorElement: <NoChatSelect />,
      },
      {
        path: `${routesConstants.liveChat}/:id?`,
        element: <LiveChatScreen />,
        // errorElement: <NoChatSelect />,
      },
      {
        path: `${routesConstants.history}/:id?`,
        element: <HistoryScreen />,
      },
      {
        path: routesConstants.contacts,
        element: <ContactsScreen />,
      },
      {
        path: routesConstants.campaigns,
        element: <CampaignsScreen />,
      },
      {
        path: `${routesConstants.campaigns}/:_id`,
        element: <CampaignsDetailScreen />,
      },
      {
        path: routesConstants.adsManager,
        element: <AdsManagerScreen />,
      },
      {
        path: routesConstants.flow,
        element: <FlowScreen />,
      },
      {
        path: routesConstants.manage,
        element: (
          <ManageLayoutScreen>
            <Outlet />
          </ManageLayoutScreen>
        ),
        children: [
          {
            path: `${routesConstants.manage}${routesConstants.agents}`,
            element: <AgentsScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.analytics}`,
            element: <AnalyticsScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.apiKey}`,
            element: <ApiKeyScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.billingUsage}`,
            element: <BillingUsagesScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.cannedMessage}`,
            element: <CannedMessageScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.liveChatSetting}`,
            element: <LiveChatSettingScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.notificationPreference}`,
            element: <NotificationPreferencesScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.optinManagement}`,
            element: <OptinManagementScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.tags}`,
            element: <TagsScreen />,
          },
          {
            path: `${routesConstants.manage}${routesConstants.userAttribute}`,
            element: <UserAttributesScreen />,
          },
        ],
      },
      {
        path: routesConstants.templateMessage,
        element: (
          <TemplateLayout>
            <Outlet />
          </TemplateLayout>
        ),
        children: [
          {
            path: `${routesConstants.templateMessage}`,
            element: <TemplateMessageScreen />,
          },
          {
            path: `${routesConstants.templateMessage}/${routesConstants.create}/:id?`,
            element: <CreateTemplateMessageScreen />,
          },
        ],
      },
      {
        path: routesConstants.profile,
        element: (
          <ProfileLayoutScreen>
            <Outlet />
          </ProfileLayoutScreen>
        ),
        children: [
          {
            path: `${routesConstants.profile}${routesConstants.yourProfile}`,
            element: <YourProfileScreen />,
          },
        ],
      },
    ],
  },
  {
    path: routesConstants.login,
    element: <LoginScreen />,
  },
  {
    path: routesConstants.register,
    element: <RegisterScreen />,
  },
];

const RootRoutes = () => {
  const routes = useRoutes(configRoutes);
  return <SocketProvider>{routes}</SocketProvider>;
};

export default RootRoutes;
